import React, { Component } from "react"
import styled from "@emotion/styled"
import { keyframes } from "@emotion/core"

const spin = keyframes`
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
`

const Spinner = styled("div")`
	border: 4px solid rgba(0, 0, 0, 0.1);
	width: 36px;
	height: 36px;
	border-radius: 50%;
	border-left-color: #09f;
	animation: ${spin} 1s linear infinite;
	margin-bottom: 1rem; /* Add some space below the spinner */
`

const LoadingContainer = styled("div")`
	display: flex;
	flex-direction: column; /* Stack spinner and text vertically */
	justify-content: center;
	align-items: center;
	min-height: 100vh; /* Take full viewport height */
	text-align: center;
	padding: 1rem;
`

const LoadingText = styled("div")`
	/* Optional: Style the text if needed */
`

class LoadingPage extends Component {
	render() {
		return (
			<LoadingContainer>
				<Spinner />
				<LoadingText>Laddar sida...</LoadingText>
			</LoadingContainer>
		)
	}
}

export default LoadingPage
